import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeliveryVehicleService {

  baseUrl = environment.baseUrl;

  constructor(
    private http:HttpClient,) { }

  delivery_active_vehicles() {
    return this.http.get(this.baseUrl + '/delivery_active_vehicles');
  }


  
}
